import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { CancellationErrorCode, CancellationReason, ResultReason } from "../sdk/Exports";
import { RecognitionStatus } from "./Exports";
export var EnumTranslation = /*#__PURE__*/function () {
  function EnumTranslation() {
    _classCallCheck(this, EnumTranslation);
  }

  _createClass(EnumTranslation, null, [{
    key: "implTranslateRecognitionResult",
    value: function implTranslateRecognitionResult(recognitionStatus) {
      var reason = ResultReason.Canceled;

      switch (recognitionStatus) {
        case RecognitionStatus.Success:
          reason = ResultReason.RecognizedSpeech;
          break;

        case RecognitionStatus.NoMatch:
        case RecognitionStatus.InitialSilenceTimeout:
        case RecognitionStatus.BabbleTimeout:
        case RecognitionStatus.EndOfDictation:
          reason = ResultReason.NoMatch;
          break;

        case RecognitionStatus.Error:
        default:
          reason = ResultReason.Canceled;
          break;
      }

      return reason;
    }
  }, {
    key: "implTranslateCancelResult",
    value: function implTranslateCancelResult(recognitionStatus) {
      var reason = CancellationReason.EndOfStream;

      switch (recognitionStatus) {
        case RecognitionStatus.Success:
        case RecognitionStatus.EndOfDictation:
        case RecognitionStatus.NoMatch:
          reason = CancellationReason.EndOfStream;
          break;

        case RecognitionStatus.InitialSilenceTimeout:
        case RecognitionStatus.BabbleTimeout:
        case RecognitionStatus.Error:
        default:
          reason = CancellationReason.Error;
          break;
      }

      return reason;
    }
  }, {
    key: "implTranslateCancelErrorCode",
    value: function implTranslateCancelErrorCode(recognitionStatus) {
      var reason = CancellationErrorCode.NoError;

      switch (recognitionStatus) {
        case RecognitionStatus.Error:
          reason = CancellationErrorCode.ServiceError;
          break;

        case RecognitionStatus.TooManyRequests:
          reason = CancellationErrorCode.TooManyRequests;
          break;

        default:
          reason = CancellationErrorCode.NoError;
          break;
      }

      return reason;
    }
  }]);

  return EnumTranslation;
}();